import { h, render } from 'vue';
import Loading from './Loading.vue';

const mount = (component, { props, children, element, app } = {}) => {
  let el = element ? element : document.createElement('div');
  let vNode = h(component, props, children);
  if (app && app._context) vNode.appContext = app._context;

  render(vNode, el);

  const destroy = () => {
    if (el) render(null, el);
    el = null;
    vNode = null;
  };

  return { vNode, destroy, el };
};

// const umount = (el) => {
//   if (typeof el.remove !== 'undefined') {
//     el.remove();
//   } else {
//     el.parentNode.removeChild(el);
//   }
// };

const instances = [];
const div = document.createElement('div');
// div.setAttribute('class', 'loading');
document.body.appendChild(div);
const instance = (options) => {
  const o = typeof options === 'string' ? { message: options } : options;

  const component = mount(Loading, { props: { modelValue: true, duration: 0, ...o } });

  document.querySelector('body').appendChild(component.el);
  instances.push(component);
  /* eslint-disable */
  return component;
};
instance.show = function loading(message, options = {}) {
  return instance({  duration: 0, message, ...options });
};


instance.clear = function clear() {
  instances.forEach((instance) => {
    instance.destroy();
  });
};

export default instance;
